// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__F6VaH","title":"FrontImage_title__2eghR"};